import { ChangeEvent } from 'react'
import { useFormContext } from 'react-hook-form'

import { DefaultElementProps } from 'common/interfaces'
import CheckboxGroupWrapper from 'components/CheckboxGroupWrapper'

import CheckboxItemWithImage from './components/CheckboxItemWithImage'
import { CheckboxGroupImage as CheckboxGroupImageProps, CheckboxImageOption } from './interface'

function renderOption(
  option: CheckboxImageOption,
  valueState: Record<string, boolean>,
  handleChange: (id: string, event: ChangeEvent<HTMLInputElement>) => void
): JSX.Element {
  return (
    <CheckboxItemWithImage option={option} valueState={valueState} handleChange={handleChange} />
  )
}

export default function CheckboxGroupImage({
  name,
  size,
  label,
  textAlign,
  options,
  direction,
  validations,
  onFocus,
  onChange,
}: CheckboxGroupImageProps & DefaultElementProps): JSX.Element {
  const { control } = useFormContext()

  const defaultValue = options.reduce(
    (acc, opt) => ({
      ...acc,
      [opt.value]: opt.defaultChecked ?? false,
    }),
    {}
  )

  return (
    <CheckboxGroupWrapper
      classNames="checkbox-wrap-image"
      control={control}
      options={options}
      name={name}
      validations={validations}
      size={size}
      label={label}
      textAlign={textAlign}
      direction={direction}
      renderOption={renderOption}
      defaultValue={defaultValue}
      onFocus={onFocus}
      onChange={onChange}
      gapSize={2}
    />
  )
}
